import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {Tab, Tabs} from 'components';
import {ExternalIntegrationPurpose} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {UserSummary} from 'types';

import {ActivityFilterType} from '../enums';
import {ActivityFilters} from '../types';

import {ComplianceAnalytics} from './ComplianceAnalytics';
import {ComplianceMessages} from './ComplianceMessages';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.COMPLIANCE;

const AVAILABLE_FILTERS = [
    ActivityFilterType.StartDate,
    ActivityFilterType.EndDate,
    ActivityFilterType.User,
    ActivityFilterType.Group,
    ActivityFilterType.Subgroup,
    ActivityFilterType.SessionId
];

type Props = {
    filters: ActivityFilters | null;
    users: UserSummary[];
    isLoading: boolean;
    setAvailableFilters: (filters: ActivityFilterType[]) => void;
    onToggleLoading: (value: boolean) => void;
};

export const Compliance = ({setAvailableFilters, ...rest}: Props) => {
    const {t} = useTranslation();

    useEffect(() => {
        setAvailableFilters(AVAILABLE_FILTERS);
    }, [setAvailableFilters]);

    return (
        <Tabs>
            <Tab name={t(T_KEYS.TABS.ANALYTICS)}>
                <ComplianceAnalytics {...rest} />
            </Tab>
            <Tab name={t(T_KEYS.TABS.MESSAGES)}>
                <ComplianceMessages {...rest} purpose={ExternalIntegrationPurpose.TextChatCompliance} />
            </Tab>
            <Tab name={t(T_KEYS.TABS.TRANSCRIPTIONS)}>
                <ComplianceMessages {...rest} purpose={ExternalIntegrationPurpose.AudioCompliance} />
            </Tab>
        </Tabs>
    );
};
